export default __webpack_public_path__ + "static/media/jd.73cfb5ad.svg";